function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M51.5014 0C36.1029 0.0189102 23.6244 12.4972 23.6055 27.8959V45.0625C23.6055 46.2476 24.5663 47.2084 25.7514 47.2084H34.3348C35.5199 47.2084 36.4807 46.2476 36.4807 45.0625V27.8959C36.4805 19.6 43.2057 12.875 51.5014 12.875C59.7971 12.875 66.5223 19.6 66.5223 27.8959V45.0625C66.5223 46.2476 67.4831 47.2084 68.6682 47.2084H77.2514C78.4365 47.2084 79.3973 46.2476 79.3973 45.0625V27.8959C79.3784 12.4972 66.8999 0.0189102 51.5014 0Z",
  fill: "#434850"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7486 42.9165H77.2486C83.1741 42.9165 87.9777 47.7201 87.9777 53.6456V92.2706C87.9777 98.1963 83.1741 103 77.2486 103H25.7486C19.8231 103 15.0195 98.1963 15.0195 92.2708V53.6458C15.0195 47.7201 19.8231 42.9165 25.7486 42.9165Z",
  fill: "#434850"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M62.2278 66.521C62.2528 60.5955 57.4695 55.7716 51.544 55.7467C45.6185 55.7217 40.7946 60.505 40.7696 66.4305C40.7523 70.5264 43.0684 74.2746 46.7392 76.0914L45.0825 87.6789C44.9166 88.8523 45.7333 89.938 46.9068 90.104C47.0062 90.1181 47.1065 90.1251 47.2069 90.1251H55.7903C56.9754 90.1372 57.9459 89.1863 57.9577 88.0011C57.9587 87.8919 57.9517 87.7827 57.936 87.6747L56.2794 76.0872C59.9053 74.2726 62.2043 70.5752 62.2278 66.521Z",
  fill: "#F5FAFF"
});

function SvgBigLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLock);
export default __webpack_public_path__ + "static/media/bigLock.b432433d.svg";
export { ForwardRef as ReactComponent };